<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
                <h3 class="font-weight-bold">Travellers History</h3>
                <div class="text-xs-right">
                    <export-excel-button :export-data="exportData"
                                         v-if="$oauth.checkIfHasPermission(['export traveller-list'])"/>
                  <refresh-button :click-function="refreshData"></refresh-button>
                </div>
            </v-flex>
            <v-flex lg12>
                <v-card>
                    <v-layout class="py-1 mx-2" row wrap>
                        <v-flex xs3 class="pb-0">
                            <v-text-field
                                flat
                                hide-details
                                placeholder="Search by typing here..."
                                prepend-inner-icon="search"
                                solo
                                v-model="filters.query"
                                @keypress.enter="fetchFiltersData"
                            />
                        </v-flex>
                        <v-flex xs3 class="pb-0">
                            <v-text-field
                                flat
                                hide-details
                                placeholder="Document Number"
                                prepend-inner-icon="filter_list"
                                solo
                                v-model="filters.document_number"
                                @keypress.enter="fetchFiltersData"
                            />
                        </v-flex>
                        <v-flex xs3 class="pb-0">

                            <flat-date-picker v-model="filters.dob" label="Select Date of Birth"
                                              @input="fetchFiltersData" :clearable="true"/>
                        </v-flex>
                        <v-flex xs3>
                            <v-autocomplete
                                :items="countries"
                                chips
                                clearable
                                deletable-chips
                                flat
                                hide-details
                                item-text="country_name"
                                item-value="id"
                                label="Filter By Country"
                                multiple
                                prepend-inner-icon="filter_list"
                                solo
                                v-model="filters.country"
                                @change="fetchFiltersData"
                            />
                        </v-flex>
                    </v-layout>
                    <v-divider/>
                    <v-card-text class="pa-0">
                        <v-data-table
                            :footer-props="footerProps"
                            :headers="headers"
                            :items="data"
                            :loading="loading"
                            :options.sync="pagination"
                            class="elevation-0"
                            hide-default-footer>
                            <template v-slot:item.country_name="{ item }">
                                <td>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <span
                                                    v-on="on">{{item.country_code}}</span>
                                        </template>
                                        <span>{{item.country_name}}</span>
                                    </v-tooltip>
                                </td>
                            </template>

                            <template v-slot:item.action="{ item }">
                                <td>

                                  <v-tooltip
                                      top
                                      v-if="!currentUser.roles.some(role => role.display_name === 'Special Bureau')"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                          @click="view(item)"
                                          color="primary"
                                          dark
                                          dense
                                          fab
                                          v-on="on"
                                          x-small
                                          :href="'/system/travellers-history/view/' + item.id"
                                          :to="'/system/travellers-history/view/' + item.id"
                                      >
                                        <v-icon small>remove_red_eye</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>View</span>
                                  </v-tooltip>

                                  <v-tooltip
                                      bottom
                                      v-if="currentUser.roles.some(role => role.display_name === 'Special Bureau')"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                          dark
                                          fab
                                          x-small
                                          color="blue darken-3 mx-2"
                                          @click="downloadAsPdf(item)"
                                          v-on="on"
                                      >
                                        <v-icon dark>mdi mdi-file-pdf</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Download As PDF</span>
                                  </v-tooltip>
                                </td>
                            </template>
                        </v-data-table>
                        <issued-visa-footer @nextClick="handleNextClick" @prevClick="handlePrevClick"
                                            :disable-next="disableNext"
                                            :disable-prev="disablePrev"
                                            :perPage="pagination.itemsPerPage"
                                            @rowChanged="fetchDataWithRow"
                                            @getCount="getCount"
                                            :total="total"
                                            :items-loading="totalItemsLoading"
                                            :showing-of="showingOf"
                        />
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import {mapActions, mapMutations, mapGetters} from 'vuex';
    import CustomDateRangePicker from "../../components/CustomDateRangePicker";
    import {commonStoreMixin} from "../../mixins/commonStoreMixin";
    import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
    import ExportExcelButton from "../../components/ExportExcelButton";
    import FlatDatePicker from "../../components/FlatDatePicker";
    import RefreshButton from "@/components/RefreshButton";
    import {VERSIONED_API_URL} from "../../config/config";
    import Http from "axios";

    export default {
        data() {
            return {
                title: "Traveller List",
                // pagination: {
                //     itemsPerPage: 25,
                //     sortBy: ["travellers.created_at"],
                //     sortDesc: ["true"]
                // },
                headers: [
                    {
                        text: 'S.N.',
                        value: 's_no',
                    },
                    {
                        text: "Full Name",
                        value: "full_name",
                    },
                    {
                        text: "Country",
                        value: "country_name",
                    },
                    {
                        text: "Gender",
                        value: "gender",

                    },
                    {
                        text: "DOB",
                        value: "dob"
                    },
                    {
                        text: "Document Number",
                        value: "document_number"
                    }
                ]
            };
        },
        components: {RefreshButton, FlatDatePicker, CustomDateRangePicker, IssuedVisaFooter, ExportExcelButton},
        mixins: [commonStoreMixin],
        computed: {
            ...mapGetters({
                loading: "TravellerHistoryReport/reportLoading",
                countries: "CountryList/all",
                currentUser: "AuthUser/user"
            })
        },

        methods: {
            ...mapActions({
                fetchCountries: "CountryList/fetchAllCountries"
            }),


            view(item) {
                this.$router.push({
                    name: "TravellerDetail",
                    params: {id: item.id.toString()}
                });
            },
          refreshData(){
            this.fetchData();
          },
          downloadAsPdf(item) {
            Http.get(`${VERSIONED_API_URL}/${item.id}/generate-report`)
                .then((res) => {
                  window.open(res.data.link, "_blank");
                })
                .catch(() => {
                  this.$store.commit("Notification/showError", "Something went wrong");
                })
          },
        },
        created() {
            if (this.$oauth.checkIfHasPermission(['read traveller-history']))
                this.headers.push(
                    {
                        text: "Action",
                        value: "action",
                        sortable: false
                    })
        },
        mounted() {
            this.stateName = 'TravellerHistoryReport';
            this.commonState = this.$store.state.TravellerHistoryReport;
            this.fetchCountries();
        }
    };
</script>
